/**
 * As per design https://ardoqcom.atlassian.net/jira/software/c/projects/ARD/issues/ARD-16851
 */
export const TIMELINE_PHASES_COLUMN_MINIMUM_WIDTH_RATIO = 0.4;

export const PHASES_ROW_INDEX_ATTRIBUTE = 'data-phases-row-index';
export const GRAPH_NODE_ID_ATTRIBUTE = 'data-graph-node-id';
export const MOUSE_HOVER_THROTTLE_DELAY = 50;

export const UNSET_POPVERS_ARGS = {
  crosshairXPosition: -1,
  graphNodeId: null,
  itemPhasesRowIndex: null,
  otherLabelIndex: null,
  popoverElementType: null,
  popoverY: 0,
  popoverX: 0,
};
